import React, { Fragment, useState, useEffect, useContext } from "react";
import { Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, Image, H6, P } from "../../AbstractElements";
import { useForm } from "react-hook-form";
import { EmailAddress, Continue } from "../../Constant";
import { megaLogo } from "../../api";
import { postResetPassword, getUserByKey } from "../../Services/Auth.service";
import { useParams } from "react-router";
const ResetTab = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();

  const [loading, setLoading] = useState(false);
  const { userKey } = useParams();
  const [userEmail, setUserEmail] = useState();
  const [toggleNewPassword, setToggleNewPassword] = useState(false);
  const [toggleConfirmPassword, setToggleConfirmPassword] = useState(false);
  const [resetPasswordRes, setResetPasswordRes] = useState(() => {
    return {
      message: null,
      color: null,
    };
  });

  const [formSubmitFlag, setFormSubmitFlag] = useState(false);
  const [linkExpired, setLinkExpired] = useState(false)


  const redirectTologin = () => {
    window.location.href = `${process.env.PUBLIC_URL}/login`;
  };

  const submitForm = (formValues) => {
    let obj = {
      newPassword: formValues.new_password,
      userKey,
    };
    setLoading(true);
    postResetPassword(obj)
      .then((result) => {
        setLoading(false);
        setFormSubmitFlag(true);
      })
      .catch((err) => {
        setResetPasswordRes({
          message: err.response?.data.message ? err.response?.data.message : "Something went wrong",
          color: "red",
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    let obj = {
      userKey,
    };
    getUserByKey(obj).then((result) => {
      if (result.data) {
        setUserEmail(result.data);
      }
    }).catch(err => {
      setLinkExpired(true)
    });
  }, []);

  const new_password = watch("new_password");

  const ValidatePassword = (value) => {
    if (!value && !new_password) return true;
    return value == new_password;
  };

  return (
    <Fragment>
      {!formSubmitFlag ? (
        <Fragment>
          {!linkExpired ? (
            <Form className="theme-form" onSubmit={handleSubmit(submitForm)}>
              <Row className="customer-logo">
                <Image
                  attrImage={{
                    className: "img-fluid d-inline",
                    src: megaLogo,
                    alt: "Logo",
                  }}
                />
              </Row>
              <Row className="forgot-pwd-content reset-password">
                <H6>Password Recovery?</H6>
                <P>email id:{userEmail || ""}</P>
              </Row>
              <FormGroup className="position-relative">
                <input
                  className="form-control"
                  placeholder="New Password"
                  {...register("new_password", {
                    required: {
                      value: true,
                      message: "New Password is required",
                    },
                  })}
                  type={toggleNewPassword ? "text" : "password"}
                  required=""
                />
                <div
                  className="show-hide show-hide-reset"
                  onClick={() => setToggleNewPassword(!toggleNewPassword)}
                >
                  <span className={toggleNewPassword ? "" : "show"}></span>
                </div>
                <span style={{ color: "red" }}>
                  {errors?.new_password?.message}
                </span>
              </FormGroup>
              <FormGroup className="position-relative">
                <input
                  className="form-control"
                  placeholder="Confirm Password"
                  {...register("confirm_password", {
                    required: {
                      value: true,
                      message: "Confirm Password is required",
                    },
                    validate: (value) =>
                      ValidatePassword(value) || "Passwords do not match",
                  })}
                  type={toggleConfirmPassword ? "text" : "password"}
                  required=""
                />

                <div
                  className="show-hide show-hide-reset"
                  onClick={() => setToggleConfirmPassword(!toggleConfirmPassword)}
                >
                  <span className={toggleConfirmPassword ? "" : "show"}></span>
                </div>
                <span style={{ color: "red" }}>
                  {errors?.confirm_password?.message}
                </span>
              </FormGroup>
              {resetPasswordRes.message ? (
                <span style={{ color: resetPasswordRes.color }}>
                  {resetPasswordRes.message}
                </span>
              ) : (
                ""
              )}
              <div className="position-relative form-group mb-0">
                <Btn
                  attrBtn={{
                    color: "primary",
                    className: "d-block w-100 mt-2",
                    disabled: loading ? loading : loading,
                    type: "submit",
                  }}
                >
                  {loading ? "LOADING..." : Continue}
                </Btn>
              </div>
              {/* <SocialAuth /> */}
            </Form>) : (
            <>
              <Row className="forgot-pwd-content">
                <H6>Password Reset</H6>
                <P>
                  Reset link has been expired. Please generate a new link to reset your password.
                </P>
              </Row>
              <div className="position-relative form-group mb-0">
                <Btn
                  attrBtn={{
                    color: "primary",
                    className: "d-block w-100 mt-2",
                    disabled: loading ? loading : loading,
                    onClick: (e) => redirectTologin(),
                  }}
                >
                  {loading ? "LOADING..." : "Back To Login"}
                </Btn>
              </div>
            </>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <Row className="forgot-pwd-content">
            <H6>Password Reset</H6>
            <P>
              Password Updated Successfully. Return Back to Login and Signin with the new password.
            </P>
          </Row>
          <div className="position-relative form-group mb-0">
            <Btn
              attrBtn={{
                color: "primary",
                className: "d-block w-100 mt-2",
                disabled: loading ? loading : loading,
                onClick: (e) => redirectTologin(),
              }}
            >
              {loading ? "LOADING..." : "Back To Login"}
            </Btn>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ResetTab;
